import { useState } from 'react';
import { LexidyMark } from '@/components/LexidyLogo';
import type { Country, Department } from '@/data/types';
import { COUNTRIES, DEPARTMENTS } from '@/data';

interface Props {
  onComplete: (sel: { country: Country; dept: Department }) => void;
}

// Department is fixed to Immigration for now (the picker step was removed).
const DEFAULT_DEPT: Department =
  DEPARTMENTS.find((d) => d.code === 'immigration') || DEPARTMENTS[0];

/** Country picker (single step). Department defaults to Immigration. */
export function Onboarding({ onComplete }: Props) {
  const [country, setCountry] = useState<Country | null>(null);

  const finish = (c: Country | null) => {
    if (c) onComplete({ country: c, dept: DEFAULT_DEPT });
  };

  return (
    <div className="onb">
      <div className="onb-shell">
        {/* LEFT — brand panel */}
        <div className="onb-left">
          <div className="onb-brand">
            <span className="onb-logo"><LexidyMark size={30} className="onb-logo-mark" /> Lexidy</span>
            <span className="onb-tag">
              Borderless
              <br />
              legal care
            </span>
          </div>
          <div className="onb-left-foot">
            <div className="onb-eyebrow">Agent Portal · © 2026 Lexidy</div>
          </div>
        </div>

        {/* RIGHT — country picker */}
        <div className="onb-right">
          <h2 className="onb-q">Which office is yours?</h2>
          <p className="onb-sub">
            Pick the jurisdiction where you work. You can switch any time from the sidebar.
          </p>
          <div className="onb-grid">
            {COUNTRIES.map((c) => (
              <button
                key={c.code}
                className={`onb-card ${country?.code === c.code ? 'selected' : ''}`}
                onClick={() => setCountry(c)}
                onDoubleClick={() => finish(c)}
              >
                <div className="onb-flag">{c.flag}</div>
                <div className="onb-cname">{c.name}</div>
                <div className="onb-cmeta">{c.offices.join(' · ')}</div>
              </button>
            ))}
          </div>

          <div className="onb-footer">
            <button className="btn" disabled={!country} onClick={() => finish(country)}>
              {country ? `Enter Agent Portal · ${country.name}` : 'Pick a jurisdiction'}
              <span>→</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
